module.exports = __webpack_public_path__ + "img/Logo_header.202ad918.svg";